<template>
  <div class="forum-follow-thought-button control-el d-inline" v-if="isLoggedIn && !loading">
    <template v-if="isFollower">
      <button class="btn btn-sm btn-primary" :class="{ disable: disabledBtn }" @click="unfollowThought">
        Nicht mehr abonnieren
      </button>
    </template>
    <template v-else>
      <button class="btn btn-sm btn-primary" :class="{ disable: disabledBtn }" @click="followThought">
        Abonnieren
      </button>
    </template>
  </div>
</template>

<script>
import { onBeforeMount, ref, watch, computed, toRef } from 'vue';

// stores
import { userStore } from '@/store/user-store';

// repositories
import { RepositoryFactory } from '@/api/repositoryFactory';
const ThoughtRepository = RepositoryFactory.get('thought');

export default {
  name: 'forum-create-comment-button',
  props: {
    thought: {
      type: Object,
      required: true,
    },
  },

  setup(props, context) {
    const thought = toRef(props, 'thought');
    const isFollower = ref(false);
    const loading = ref(true);
    const disabledBtn = ref(false);

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    //
    //-----------------METHODS------------------
    //

    function initThoughtFollow() {
      // fetch follow info if user is logged in
      if (isLoggedIn.value) {
        ThoughtRepository.getFollow(thought.value.id)
          .then(resp => {
            if (resp.is_follower) {
              isFollower.value = true;
            } else {
              isFollower.value = false;
            }
            loading.value = false;
          })
          .catch(err => {
            console.log(err);
            isFollower.value = false;
          });
      }
    }
    function followThought() {
      disabledBtn.value = true;
      // follow thought
      ThoughtRepository.postFollow(thought.value.id)
        .then(resp => {
          if (resp.is_follower) {
            isFollower.value = true;
          } else {
            isFollower.value = false;
          }
          disabledBtn.value = false;
        })
        .catch(err => {
          console.log(err);
          isFollower.value = false;
          disabledBtn.value = false;
        });
    }

    function unfollowThought() {
      disabledBtn.value = true;
      // unfollow thought
      ThoughtRepository.deleteFollow(thought.value.id)
        .then(resp => {
          if (resp.is_follower) {
            isFollower.value = true;
          } else {
            isFollower.value = false;
          }
          disabledBtn.value = false;
        })
        .catch(err => {
          console.log(err);
          isFollower.value = false;
          disabledBtn.value = false;
        });
    }

    //
    //-----------------WATCHERS------------------
    //
    watch(
      () => userStore.getState().user,
      (newUser, oldUser) => {
        // if logged in user changes make sure to refetch data
        if ((newUser == null && oldUser) || (newUser && oldUser == null) || newUser?.id != oldUser?.id) {
          initThoughtFollow();
        }
      }
    );

    onBeforeMount(() => {
      initThoughtFollow();
    });

    return {
      // REFS
      loading,
      isFollower,
      disabledBtn,

      // COMPUTED
      isLoggedIn,

      // METHODS
      followThought,
      unfollowThought,
    };
  },

  components: {},
};
</script>
